<template>
    <section v-if="psList && psList.length">
        <div class="touch-strip promotion-strip" @click="changeShowDiscount">
            <a href="javascript:;">
                <div class="content" style="height:24px">
                    <h3>优惠</h3>
                    <ul class="detail-promotionList">
                        <li v-for="(flag, index) in promotionFlagList" class="promo-tag" v-if="index < 3" :key="index">
                            <span>{{typeFlag[flag]}}</span>
                        </li>
                    </ul>
                    <span class="more">{{psList.length}}个</span>
                    <i class="arrow"></i>
                </div>
            </a>
        </div>
        <Popup :show="showDiscount" title="优惠活动" class="discount-popup-ctn">
            <div class="discount-popup-inner">
                <dl class="discount-popup-list" v-for="(promotion, index) in psList" :key="index">
                    <dt class="title">
                        <span class="label"><span>{{typeFlag[promotion.promotionFlag]}}</span></span>
                        <span class="content">{{promotion.retailPsName}}</span>
                    </dt>
                    <dd>
                        <span class="label">促销方式</span>
                        <span class="content">{{promotion.typeName}}</span>
                    </dd>
                    <dd>
                        <span class="label">参加时间</span>
                        <span class="content">{{promotion.beginDate}}-{{promotion.endDate}}</span>
                    </dd>
                    <dd class="plan-date" v-if="Array.isArray(promotion.planDateList) && promotion.planDateList.length">
                        <span class="label">适用团期</span>
                        <ul class="content">
                            <li v-for="item in promotion.planDateList" :key="item.month" v-if="item.dates">
                                <span>{{item.month}}：</span>{{item.dates}}
                            </li>
                        </ul>
                    </dd>
                    <dd>
                        <span class="label">活动内容</span>
                        <span class="content" ref="content">{{promotion.webHtml.trim()}}</span>
                    </dd>
                </dl>
            </div>
        </Popup>
    </section>
</template>

<script>
import Popup from '@/components/Popup';
export default {
    name: 'discount',
    data() {
        return {
            typeFlag: {
                1:'银行优惠',
                2: '金融优惠', 
                3: '立减优惠',
                4: '优惠券优惠',
                5:'会员优惠',
                6:'多订优惠',
                7: '早定优惠', 
                8:'返券优惠',
                13:'砍价优惠',
                614:'途牛黑卡优惠'
            },
            showDiscount: {isShow: false}
        }
    },
    props: {
        psList: {
            type: Array,
            default: function () {
                return []
            }
        },
        promotionFlagList: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
    },
    created(){
        String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,'').replace(/\n/g,"<br/>")}
    },
    mounted(){
        this.renderWebHtml()
    },
    methods: {
        changeShowDiscount() {
            this.showDiscount.isShow = true;
        },
        renderWebHtml(){
            let content = this.$refs.content;
            for(let index in content ){
               content[index].innerHTML = content[index].innerText;
            }
        }
    },
    components: {
        Popup
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';

//优惠信息
.detail-promotionList {
    float: left;
    height: 16px;
    margin: 0 0 0 10px;
    li.promo-tag {
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
        margin-right: 5px;
        padding: 0 5px;
        height: 16px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: #ff6436;
        border-radius: 3px;
        border: 1px solid currentColor;
        @supports (border-width: 0.5px) {
            border-width: 0.5px;
            line-height: 16px;
        }
        span {
            position: relative;
            display: block;
            transform: scale(0.9167);
            transform-origin: center;
        }
    }
    li.coupon {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        padding: 0 11px;
        height: 16px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: #ff5500;
        border-radius: 3px;
        background-color: #ffeee8;
        &:before {
            content: "";
            position: absolute;
            left: 0%;
            top: 50%;
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background: #fff;
            z-index: 1;
            transform: translateX(-50%) translateY(-50%);
        }
        &:after {
            content: "";
            position: absolute;
            right: 0%;
            top: 50%;
            width: 5px;
            height: 5px;
            border-radius: 100%;
            background: #fff;
            z-index: 1;
            transform: translateX(50%) translateY(-50%);
        }
        span {
            position: relative;
            display: block;
            transform: scale(0.9167);
            transform-origin: center;
        }
    }
}
.promotion-strip {
    a {
        display: block;
        padding: 13px 0px 13px 0;
        font-size: 0;
        @include clearfix;
    }
    h3 {
        float: left;
        font-size: 14px;
        vertical-align: middle;
    }
}
.discount-popup-inner {
    height: 400px;
    @supports (height: 50vh) {
        height: 50vh;
    }
    overflow: auto;
    -webkit-overflow-scrolling : touch;
}
.discount-popup-list{
    padding: 0 18px;
    background: #fff;
    dt {
        padding: 15px 0 8px;
        color: #383838;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        overflow: hidden;
        & > span {
            vertical-align: middle;
        }
        .label{
            display: inline-block;
            margin-right: 6px;
            padding: 0 5px;
            height: 16px;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            color: #ff6436;
            border-radius: 2px;
            background: #ffe8e7;
            span {
                position: relative;
                display: block;
                transform: scale(0.9167);
                transform-origin: center;
            }
        } 
    }
    dd {
        position: relative;
        margin-bottom: 2px;
        padding-left: 62px;
        font-size: 13px;
        line-height: 21px;
        min-height: 21px;
        color: #666;
        .label {
            position: absolute;
            left: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Discount.vue